import { AddressType } from 'lane-shared/types/AddressType';

import {
  geocodeByAddress,
  getLatLng, // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'react-places-autocomplete'. Remove this comment to see the full error message
} from 'react-places-autocomplete';

function getComponent(components: any, name: any) {
  const component = components
    .filter((c: any) => c != null)
    .find((component: any) =>
      component.types.find((type: any) => type === name)
    );

  return component && component.long_name ? component.long_name : '';
}

/**
 * Geocodes a selected place description into an AddressType. Throws if the
 * Google geocoder rejects (e.g. ZERO_RESULTS); callers decide how to surface it.
 */
export async function buildAddress(item: string): Promise<AddressType> {
  const results = await geocodeByAddress(item);
  const location = await getLatLng(results[0]);
  const components = results[0].address_components;

  const address: AddressType = {
    street1: `${getComponent(components, 'street_number')} ${getComponent(
      components,
      'route'
    )}`,
    city: getComponent(components, 'locality'),
    state: getComponent(components, 'administrative_area_level_1'),
    country: getComponent(components, 'country'),
    code: getComponent(components, 'postal_code'),
    geo: {
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ longitude: any; latitude: any; }' is not a... Remove this comment to see the full error message
      longitude: location.lng,
      latitude: location.lat,
    },
  };

  return address;
}
